import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=12170e47&scoped=true"
import script from "./AboutSection.vue?vue&type=script&lang=js"
export * from "./AboutSection.vue?vue&type=script&lang=js"
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=12170e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12170e47",
  null
  
)

export default component.exports